/**
 * デバイス判定
 *
 * @param {String} device - 'pc' または 'sp'
 * @return {boolean}
 */
export const mq = (device) => {
  const isSP = window.matchMedia("(max-width: 768.9px)").matches;
  const isPC = window.matchMedia("(min-width: 769px)").matches;

  if (device === "sp") {
    return isSP;
  }
  if (device === "pc") {
    return isPC;
  }
  return false;
};

/**
 * 一意なIDを生成する（aria-controls などの紐付け用）
 *
 * @param {String} prefix - IDの接頭辞
 * @return {String}
 */
let uidCounter = 0;
export const uid = (prefix = "uid") => {
  uidCounter += 1;
  return `${prefix}-${uidCounter}`;
};

/**
 * data属性に書かれたJSONをパースする
 * 壊れたJSONでもページ全体を落とさず、フォールバックを返す
 *
 * @param {HTMLElement} el - 対象要素
 * @param {String} name - dataset のキー名（例: "sliderOptions"）
 * @param {Object} fallback - パースできなかった場合の値
 * @return {Object}
 */
export const parseJsonAttr = (el, name, fallback = {}) => {
  const raw = el?.dataset?.[name];
  if (!raw) return fallback;

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : fallback;
  } catch (error) {
    console.warn(`[utils] data-${name} のJSONを解析できませんでした:`, raw, error);
    return fallback;
  }
};
